import { useState } from "react";
import { Car, CheckCircle2 } from "lucide-react";
import ConsortiumEditModal from "./ConsortiumEditModal";

var STATUS_MAP = {
  ativo: { cls: "bg-emerald-100 text-emerald-700", label: "Ativo" },
  contemplado: { cls: "bg-blue-100 text-blue-700", label: "Contemplado" },
  em_atraso: { cls: "bg-red-100 text-red-700", label: "Em Atraso" },
  cancelado: { cls: "bg-gray-200 text-gray-600", label: "Cancelado" },
  transferido: { cls: "bg-gray-300 text-gray-500", label: "Transferido" },
};

function formatCurrency(v) {
  if (v == null || v === 0) return "R$ 0";
  return "R$ " + Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2 });
}

export default function ConsortiumsSection({ consortiums, onRefresh }) {
  var selectedState = useState(null);
  var selected = selectedState[0];
  var setSelected = selectedState[1];

  if (!consortiums || consortiums.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-testid="profile-consortiums-section">
        <h2 className="text-base font-bold text-[#0A2F3D] mb-3 flex items-center gap-2"><Car className="w-5 h-5 text-[#F26A4B]" />Consorcios</h2>
        <p className="text-sm text-gray-400 text-center py-6">Nenhum consorcio vinculado</p>
      </div>
    );
  }

  function handleRowClick(c) {
    setSelected(c);
  }

  function handleClose() {
    setSelected(null);
  }

  function handleSaved() {
    setSelected(null);
    if (onRefresh) onRefresh();
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6" data-testid="profile-consortiums-section">
      <h2 className="text-base font-bold text-[#0A2F3D] mb-4 flex items-center gap-2">
        <Car className="w-5 h-5 text-[#F26A4B]" />Consorcios
        <span className="ml-auto text-xs font-normal text-gray-400">{consortiums.length} registro{consortiums.length !== 1 ? "s" : ""}</span>
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="profile-consortiums-table">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50/50">
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Grupo</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Cota</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Administradora</th>
              <th className="text-right py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Carta</th>
              <th className="text-right py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Parcela</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden lg:table-cell">Parcelas</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Status</th>
            </tr>
          </thead>
          <tbody>
            {consortiums.map(function(c) {
              var st = STATUS_MAP[c.status] || { cls: "bg-gray-100 text-gray-600", label: c.status };
              var isTransferred = c.status === "transferido";
              var rowCls = isTransferred
                ? "border-b border-gray-50 bg-gray-50/60 opacity-60 cursor-pointer transition-colors"
                : "border-b border-gray-50 hover:bg-[#F26A4B]/5 cursor-pointer transition-colors";
              return (
                <tr key={c.id}
                  onClick={function() { handleRowClick(c); }}
                  className={rowCls}
                  data-testid={"profile-consortium-" + c.id}>
                  <td className="py-2.5 px-3 font-medium text-[#0A2F3D]">{c.grupo || "-"}</td>
                  <td className="py-2.5 px-3 text-gray-600">{c.cota || "-"}</td>
                  <td className="py-2.5 px-3 text-gray-500 hidden sm:table-cell">{c.administrator || "-"}</td>
                  <td className="py-2.5 px-3 text-right text-gray-600 hidden md:table-cell">{formatCurrency(c.value)}</td>
                  <td className="py-2.5 px-3 text-right text-gray-600 hidden md:table-cell">{formatCurrency(c.installment_value)}</td>
                  <td className="py-2.5 px-3 text-center text-gray-500 hidden lg:table-cell">{c.installments_paid}/{c.installments_total}</td>
                  <td className="py-2.5 px-3 text-center">
                    <span className={"px-2 py-0.5 text-xs font-medium rounded-full inline-flex items-center gap-1 " + st.cls}>
                      <CheckCircle2 className="w-3 h-3" />{st.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[10px] text-gray-400 mt-2 text-center">Clique em uma linha para ver detalhes e editar</p>

      {selected && (
        <ConsortiumEditModal
          consortium={selected}
          open={!!selected}
          onClose={handleClose}
          onSaved={handleSaved}
        />
      )}
    </div>
  );
}
